import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar    from './Sidebar';
import Header     from './Header';

export default function Layout() {
  const [sidebarAberta, setSidebarAberta] = useState(true);

  return (
    <div className="flex h-screen overflow-hidden bg-surface">
      {/* Sidebar */}
      <Sidebar aberta={sidebarAberta} onFechar={() => setSidebarAberta(false)} />

      {/* Overlay mobile */}
      {sidebarAberta && (
        <div
          className="lg:hidden fixed inset-0 bg-black/60 z-20"
          onClick={() => setSidebarAberta(false)}
        />
      )}

      {/* Conteúdo principal */}
      <div className="flex-1 flex flex-col min-w-0 overflow-hidden">
        <Header onAbrirSidebar={() => setSidebarAberta(true)} />
        <main className="flex-1 overflow-y-auto p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
